import { DateTimeService, useTimezone } from '@mews/framework';

interface ReportIntervalLocal {
    startDate: string;
    endDate: string;
}

export const useReportIntervalLocal = ({ startDate, endDate }: ReportIntervalLocal) => {
    const timezone = useTimezone();
    const startDateTime = DateTimeService.fromUtcString(startDate, timezone);
    const endDateTime = DateTimeService.fromUtcString(endDate, timezone);

    return {
        start: startDateTime.value,
        end: endDateTime.value,
    };
};
